import PropTypes from "prop-types";
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

export const DETAIL_MAP_LOADING_KEYS = {
  surroundingRoutes: "surroundingRoutes",
};

const DetailMapLoadingContext = createContext({
  loadingStates: {},
  setLoadingState: () => {},
});

export const DetailMapLoadingProvider = ({ children }) => {
  const [loadingStates, setLoadingStates] = useState({});

  const setLoadingState = useCallback((key, isLoading) => {
    if (!key) return;

    setLoadingStates((currentLoadingStates) => {
      const isCurrentlyLoading = Boolean(currentLoadingStates[key]);

      if (isCurrentlyLoading === isLoading) {
        return currentLoadingStates;
      }

      if (isLoading) {
        return {
          ...currentLoadingStates,
          [key]: true,
        };
      }

      const nextLoadingStates = { ...currentLoadingStates };
      delete nextLoadingStates[key];
      return nextLoadingStates;
    });
  }, []);

  const value = useMemo(
    () => ({
      loadingStates,
      setLoadingState,
    }),
    [loadingStates, setLoadingState]
  );

  return (
    <DetailMapLoadingContext.Provider value={value}>
      {children}
    </DetailMapLoadingContext.Provider>
  );
};

DetailMapLoadingProvider.propTypes = {
  children: PropTypes.node,
};

export const useDetailMapLoading = () => useContext(DetailMapLoadingContext);
